import { type ContentColumnReadContent } from '../content-column-read.ts';

export type PageStatusReadContent = ContentColumnReadContent<'page-status'>;
export const EMPTY_PAGE_STATUS_CONTENT: PageStatusReadContent = Object.freeze({
  kind: 'page-status',
  loadingWidth: 0,
  openLinksInNewTab: false,
  items: Object.freeze([])
});
